/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const p = {
  before: "before",
  after: "after",
  forbidden: "forbidden"
}, D = (t, n) => (t == null ? void 0 : t.parentElement) !== (n == null ? void 0 : n.parentElement);
function b(t) {
  const { clientTop: n, clientLeft: o } = e(t), { pageYOffset: f, pageXOffset: c } = u(t), { top: i, left: s } = t.getBoundingClientRect();
  return {
    top: i + f - n,
    left: s + c - o
  };
}
const e = (t) => t == null ? void 0 : t.ownerDocument.documentElement, u = (t) => t == null ? void 0 : t.ownerDocument.defaultView;
export {
  p as dropDirection,
  b as getOffset,
  D as isDifferentParent
};
